import { ReactNode } from "react";
import { createStylesheet } from "../../../_app/utils/styles";
import { UICard, UIGrid } from "../../../_app/components";

interface ContactCardProps {
  icon: ReactNode;
  children: ReactNode;
}

const ContactCard = ({ icon, children }: ContactCardProps) => {
  const classes = useStyles();

  return (
    <UIGrid size={{ xs: 12, lg: 4 }}>
      <div className={classes.wrapper}>
        <div className={classes.circle}>{icon}</div>
        <UICard
          variant="outlined"
          height="160px"
          contentStyle={{
            alignItems: "center",
            paddingTop: "40px",
            paddingBottom: "8px",
          }}
        >
          {children}
        </UICard>
      </div>
    </UIGrid>
  );
};

const useStyles = createStylesheet((theme) => ({
  wrapper: {
    position: "relative",
    paddingTop: "35px",
  },
  circle: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "70px",
    height: "70px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "35px",
    border: `1px solid ${theme.palette.grey[200]}`,
    backgroundColor: "white",
    zIndex: 1,
  },
}));

export default ContactCard;
